import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, UrlTree, NavigationExtras } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LocalizedRouterService {
    constructor(
        private router: Router,
        private route: ActivatedRoute  // route attiva corrente
    ) { }

    /**
     * Naviga a un path pulito (senza prefisso lingua),
     * il servizio aggiunge automaticamente il prefisso della lingua corrente.
     * paths: array di segmenti, es ['search', 'details']
     */
    navigate(paths: (string | number)[] | string, extras: NavigationExtras = {}): Promise<boolean> {
        let segments: string[];

        if (typeof paths === 'string') {
            segments = [paths];
        } else {
            // Convertiamo tutti i segmenti in stringhe
            segments = paths.map(p => String(p));
        }

        const fullPath = [this.getCurrentLang(), ...segments];

        return this.router.navigate(fullPath, extras);
    }


    /**
     * Crea un UrlTree con prefisso lingua
     */
    createUrlTree(paths: string[] | string, extras: any = {}): UrlTree {
        const lang = this.getCurrentLang();
        const segments = typeof paths === 'string' ? [paths] : paths;
        return this.router.createUrlTree([lang, ...segments], extras);
    }

    /**
     * Recupera la lingua attuale dal route o da un servizio/stato
     */
    getCurrentLang(): string {
        // ad esempio puoi leggere da ActivatedRoute parent params
        const snapshot = this.route.snapshot.root;
        // cerchi il primo segmento param “lang”
        let lang = snapshot.firstChild?.params['lang'];
        if (!lang) {
            // fallback: lingua del browser o default
            const browserLang = navigator.language.split('-')[0];
            // fai validazione come nel guard
            lang = browserLang;  // o default preset
        }
        return lang;
    }
}
